import { Component, Input } from '@angular/core';
import { GoogleReview } from '../landing-page.models';

@Component({
  selector: 'app-reviews-section',
  templateUrl: './reviews-section.component.html',
  styleUrls: ['./reviews-section.component.scss'],
  standalone: false
})
export class ReviewsSectionComponent {
  @Input() reviews: GoogleReview[] = [];
  @Input() average: number | null | undefined;
  readonly previewLength = 170;
  private readonly expandedReviewIds = new Set<string>();

  previewText(text: string): string {
    if (text.length <= this.previewLength) {
      return text;
    }

    const excerpt = text.slice(0, this.previewLength);
    const lastSpace = excerpt.lastIndexOf(' ');
    return `${excerpt.slice(0, lastSpace > 0 ? lastSpace : this.previewLength).trimEnd()}…`;
  }

  isExpanded(id: string): boolean {
    return this.expandedReviewIds.has(id);
  }

  toggleReview(id: string): void {
    if (this.expandedReviewIds.has(id)) {
      this.expandedReviewIds.delete(id);
    } else {
      this.expandedReviewIds.add(id);
    }
  }

  stars(rating: number): string {
    const safeRating = Math.min(5, Math.max(0, Math.round(rating)));
    return `${'★'.repeat(safeRating)}${'☆'.repeat(5 - safeRating)}`;
  }
}
